export * from './get-device-size/get-device-size';
export * from './get-op-system/get-op-system';
